import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import {
  GetList,
  GetHealthScreeningList,
} from "../../StateManagement/Reducers/HealthProfileState";

import TopNav from "../TopNav";
import Lists from "./Lists";
import LifestyleDiet from "./LifestyleDiet";
import HealthScreening from "./HealthScreening";
import Loading from "../StyledComponents/Loading";

import { BodyContainer } from "../StyledComponents";
import {
  SubHeading,
  DropDown,
  DropDownListContainer,
  DropDownList,
  ListItem,
  Div,
} from "./styles";

import { AiOutlineDown } from "react-icons/ai";

const HealthProfile = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const inputNotRef = useRef(null);

  const [dropDown, setDropDown] = useState(false);
  const [selectedItem, setSelectedItem] = useState(
    state
      ? state.type.type === "medication"
        ? "Medication"
        : state.type.type === "medical_problem"
          ? "Problems"
          : state.type.type === "allergy"
            ? "Allergies"
            : state.type.type === "health_screening"
              ? "Health Screening"
              : "Lab Orders"
      : "Problems",
  );
  const [type, setType] = useState(
    state
      ? state.type.type === "medication"
        ? "medication"
        : state.type.type === "medical_problem"
          ? "medical_problem"
          : state.type.type === "allergy"
            ? "allergy"
            : state.type.type === "health_screening"
              ? "health_screening"
              : "lab"
      : "medical_problem",
  );

  let accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozoportal");

  const Items =
    accountType === -1
      ? [
          "Problems",
          "Allergies",
          "Medication",
          "Lifestyle & Diet Recommendation",
          "Health Screening",
        ]
      : [
          "Problems",
          "Allergies",
          "Lab Orders",
          "Medication",
          "Lifestyle & Diet Recommendation",
          "Health Screening",
        ];

  const LoadingRes = useSelector((state) => state.HealthProfile.HealthLoading);

  const Toggling = () => setDropDown((prevState) => !prevState);

  const ClickedItem = (item) => () => {
    setSelectedItem(item);
    setDropDown((prevState) => !prevState);

    if (item === "Problems") {
      setType("medical_problem");
    } else if (item === "Allergies") {
      setType("allergy");
    } else if (item === "Medication") {
      setType("medication");
    } else if (item === "Lifestyle & Diet Recommendation") {
      setType("lifestyle");
    } else if (item === "Health Screening") {
      setType("health_screening");
    } else {
      setType("lab");
    }
  };

  const handleClick1 = (e) => {
    if (inputNotRef.current && !inputNotRef.current.contains(e.target)) {
      setDropDown(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mouseup", handleClick1);

    return () => {
      document.addEventListener("mouseup", handleClick1);
    };
  }, []);

  useEffect(() => {
    if (type === "health_screening") {
      dispatch(GetHealthScreeningList());
    } else if (type !== "lifestyle") {
      dispatch(GetList(type));
    }
  }, [type, dispatch]);

  return (
    <>
      <TopNav title="Health Profile" />
      {LoadingRes ? (
        <Loading />
      ) : (
        <BodyContainer
          paddingLeft="10px"
          paddingTop="2px"
          style={{
            background: "#F3F4F6",
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "24px",
              marginBottom: "2px",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            {Items.map((item, index) => {
              const formattedType =
                item === "Problems"
                  ? "medical_problem"
                  : item === "Allergies"
                    ? "allergy"
                    : item === "Medication"
                      ? "medication"
                      : item === "Lifestyle & Diet Recommendation"
                        ? "lifestyle"
                        : item === "Health Screening"
                          ? "health_screening"
                          : "lab";

              const isActive = type === formattedType;

              return (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedItem(item);
                    setType(formattedType);
                  }}
                  style={{
                    cursor: "pointer",
                    paddingBottom: "6px",
                    fontWeight: isActive ? "600" : "400",
                    color: isActive ? "#2563EB" : "#6B7280",
                    borderBottom: isActive
                      ? "2px solid #2563EB"
                      : "2px solid transparent",
                    transition: "0.2s ease",
                  }}
                >
                  {item}
                </div>
              );
            })}
          </div>

          {type === "lifestyle" ? (
            <div style={{ marginTop: "20px" }}>
              {/* Lifestyle component will go here */}
              <LifestyleDiet />
            </div>
          ) : type === "health_screening" ? (
            <HealthScreening />
          ) : (
            <Lists list={selectedItem} />
          )}
        </BodyContainer>
      )}
    </>
  );
};

export default HealthProfile;
